import { environment } from '../environments/environment';
import { devBaseUrl, devPartnerApiUrl, liveBaseUrl, livePartnerApiUrl } from './constants';

export const baseUrl = () => {
  if (environment.debug) {
    return devBaseUrl;
  }
  return liveBaseUrl;
};

export const partnerApiUrl = () => (environment.debug ? devPartnerApiUrl : livePartnerApiUrl);
